// src/components/landing/FloatingAiCoursesButton.jsx
import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from '../../contexts/ThemeContext';

export default function FloatingAiCoursesButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const { mode } = useContext(ThemeContext);
  const isDark = mode === 'dark';

  const handleClick = () => {
    if (location.pathname === '/') {
      const element = document.getElementById('course-groups');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        return;
      }
    }
    navigate('/course-groups');
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        position: 'fixed',
        top: { xs: 90, sm: 102, md: 118 },
        left: { xs: 12, sm: 20, md: 32 },
        zIndex: 1100,
        cursor: 'pointer',
        userSelect: 'none',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 45%, #991b1b 100%)',
          color: '#ffffff',
          borderRadius: '50px',
          px: { xs: 2.5, sm: 3.2, md: 3.8 },
          py: { xs: 1.2, sm: 1.5, md: 1.7 },
          boxShadow: isDark
            ? '0 15px 40px rgba(220, 38, 38, 0.75), 0 0 30px rgba(245, 158, 11, 0.5)'
            : '0 14px 35px rgba(220, 38, 38, 0.6), 0 0 25px rgba(239, 68, 68, 0.45)',
          border: '2.5px solid #fde047',
          backdropFilter: 'blur(16px)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          animation: 'offerPulse 2.5s infinite alternate',
          display: 'flex',
          alignItems: 'center',
          gap: { xs: 1.2, md: 1.6 },
          whiteSpace: 'nowrap',
          '&:hover': {
            transform: 'translateY(-4px) scale(1.04)',
            background: 'linear-gradient(135deg, #f43f5e 0%, #e11d48 45%, #b91c1c 100%)',
            boxShadow: '0 20px 50px rgba(220, 38, 38, 0.9), 0 0 40px rgba(253, 224, 71, 0.7)',
            borderColor: '#ffffff',
          },
          '@keyframes offerPulse': {
            '0%': { boxShadow: '0 10px 30px rgba(220, 38, 38, 0.5), 0 0 15px rgba(239, 68, 68, 0.3)' },
            '100%': { boxShadow: '0 18px 45px rgba(220, 38, 38, 0.85), 0 0 35px rgba(253, 224, 71, 0.6)' },
          },
        }}
      >
        <Typography
          sx={{
            fontWeight: 900,
            fontSize: { xs: '0.88rem', sm: '1.05rem', md: '1.16rem' },
            color: '#ffffff',
            letterSpacing: 0.4,
            textShadow: '0 2px 6px rgba(0,0,0,0.35)',
          }}
        >
          Emerging & Futuristic Courses
        </Typography>

        <Box
          sx={{
            bgcolor: '#ffffff',
            color: '#dc2626',
            borderRadius: '50%',
            width: { xs: 26, sm: 30 },
            height: { xs: 26, sm: 30 },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 900,
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            flexShrink: 0,
            transition: 'transform 0.2s',
            '&:hover': { transform: 'scale(1.15)' },
          }}
        >
          <ArrowForwardIcon sx={{ fontSize: { xs: '0.9rem', sm: '1.1rem' } }} />
        </Box>
      </Box>
    </Box>
  );
}
